import { oncallFetch } from "sc/backend/oncall/fetch-helper";

//noinspection OverlyComplexFunctionJS
export default function*(
  id,
  firstName,
  lastName,
  workPhone,
  cellPhone,
  homePhone,
  regionId,
  enabled,
  workPhonePriority,
  cellPhonePriority,
  homePhonePriority,
) {
  return yield oncallFetch("/api/oncall/partners/engineers/update", {
    id,
    firstName,
    lastName,
    workPhone,
    cellPhone,
    homePhone,
    regionId,
    enabled,
    workPhonePriority,
    cellPhonePriority,
    homePhonePriority,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/engineers/update.js